import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Input from '@material-ui/core/Input';
import DialogTitle from '@material-ui/core/DialogTitle';

import PulseLoader from 'react-spinners/PulseLoader';

import CssConfirmDeletionDialog from './UrlDialog.scss';

function UrlDialog(props) {
  const {
    abortText,
    url,
    inProgress,
    onAgree,
    onClose,
    proceedText,
    title,
    placeholder,
    open,
  } = props;
  const [newValue, setNewValue] = React.useState(url);
  const inputRef = React.useRef(null);

  useStyles(CssConfirmDeletionDialog);

  const handleInputChange = event => {
    setNewValue(event.target.value);
  };

  const handleConfirm = () => {
    if (!newValue) {
      return;
    }

    onAgree(newValue);
  };

  const handleEnterKey = event => {
    if (!newValue) {
      return;
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      handleConfirm();
    }
  };

  useEffect(
    () => {
      if (!open) {
        setNewValue('');
      } else if (url) {
        setNewValue(url);
      }
    },
    [open, url],
  );

  useEffect(
    () => {
      if (props.open) {
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        });
      }
    },
    [props.open],
  );

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableRestoreFocus
      disableEnforceFocus
      className="confirm-deletion"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <Input
          defaultValue={url}
          value={newValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          autoCapitalize="off"
          className="confirm-deletion__input"
          fullWidth
          onKeyDown={handleEnterKey}
          inputRef={inputRef}
        />
      </DialogContent>
      <DialogActions className="confirm-deletion__actions">
        <Button
          className="confirm-deletion__button confirm-deletion__button--cancel"
          size="large"
          onClick={onClose}
          variant="contained"
          autoFocus
        >
          {abortText}
        </Button>
        <Button
          className="confirm-deletion__button"
          size="large"
          disabled={!newValue}
          onClick={handleConfirm}
          variant="contained"
          color="primary"
        >
          {inProgress ? <PulseLoader loading color="#fff" sizeUnit="px" size={10} /> : proceedText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

UrlDialog.propTypes = {
  abortText: PropTypes.string,
  url: PropTypes.string,
  placeholder: PropTypes.string,
  inProgress: PropTypes.bool,
  onAgree: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  proceedText: PropTypes.string,
  title: PropTypes.string,
};

UrlDialog.defaultProps = {
  abortText: 'Cancel',
  url: null,
  inProgress: false,
  onAgree: () => {},
  onClose: () => {},
  open: false,
  proceedText: 'Confirm',
  placeholder: 'Enter Link here',
  title: 'Add link',
};

export default UrlDialog;
